import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryRoute from "@/pages/category/CategoryRoute";
import Detail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import SiteLayout from "@/components/feature/SiteLayout";
import type { RouteObject } from "react-router-dom";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <SiteLayout>
        <Home />
      </SiteLayout>
    ),
  },
  {
    path: "/category/:type",
    element: <CategoryRoute />,
  },
  {
    path: "/detail/:id",
    element: (
      <SiteLayout>
        <Detail />
      </SiteLayout>
    ),
  },
  {
    path: "/search",
    element: (
      <SiteLayout>
        <Search />
      </SiteLayout>
    ),
  },
  {
    path: "/about",
    element: (
      <SiteLayout>
        <About />
      </SiteLayout>
    ),
  },
  {
    path: "*",
    element: (
      <SiteLayout>
        <NotFound />
      </SiteLayout>
    ),
  },
];

export default routes;